<template>
  <div class="page">
    <a-card title="新建定制游订单" :bordered="false" :bodyStyle="{paddingTop:'10px'}"
            :headStyle="{ borderBottom: '0px', fontSize: '18px' }">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item prop="travelMadeOrderName" label="方案名称">
          <a-input v-model="ruleForm.travelMadeOrderName" :maxLength="100" placeholder="请输入"/>
        </a-form-model-item>
        <a-form-model-item label="方案附件" required>
          <div>
            <a-upload-dragger
              name="file"
              :multiple="false"
              :action="uploadFileUrl"
              :before-upload="handleBefore"
              :file-list="fileList"
              @change="handleChange"
              :remove="handleRemove"
            >
              <p class="ant-upload-drag-icon" style="margin-bottom:10px;">
                <a-icon type="inbox"/>
              </p>
              <p class="ant-upload-hint">拖拽或点击方案文件</p>
            </a-upload-dragger>
          </div>
        </a-form-model-item>
        <a-form-model-item label="购买人数">
          <a-col :span="6">
            <a-form-model-item label="成人" style="margin-bottom:0px;" prop="travelMadeOrderAdultsNum"
                               :label-col="{span:6}" :wrapper-col="{ span: 14}">
              <a-input-number v-model="ruleForm.travelMadeOrderAdultsNum" :min="1" :max="100"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="儿童" style="margin-bottom:0px;" prop="travelMadeOrderChildNum"
                               :label-col="{span:6}" :wrapper-col="{ span: 14}">
              <a-input-number v-model="ruleForm.travelMadeOrderChildNum" :min="0" :max="100"/>
            </a-form-model-item>
          </a-col>
        </a-form-model-item>
        <a-form-model-item label="出游时间" prop="selectDate">
          <a-date-picker v-model="ruleForm.selectDate" @change="onDateChange" format="YYYY-MM-DD"
                         :disabled-date="disabledDate"/>
        </a-form-model-item>
        <a-form-model-item label="姓名" prop="travelMadeOrderContact">
          <a-input v-model="ruleForm.travelMadeOrderContact" :maxLength="50" placeholder="请输入姓名"/>
        </a-form-model-item>
        <a-form-model-item prop="travelMadeOrderMobile" label="手机号">
          <a-input v-model="ruleForm.travelMadeOrderMobile" :maxLength="11" placeholder="请输入手机号"/>
        </a-form-model-item>
        <a-form-model-item label="内部团号">
          <a-input v-model="ruleForm.travelMadeOrderInternalNo" :maxLength="50" placeholder="请输入手机号"/>
        </a-form-model-item>
        <a-form-model-item prop="travelMadeOrderAmt" label="订单金额">
          <a-input class="maxW400" prefix="￥" suffix="RMB" v-model="ruleForm.travelMadeOrderAmt" :maxLength="30"
                   placeholder="请输入订单金额"/>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">确认生成</a-button>
          <a-button @click="goOrderList" style="margin-left: 10px">返回</a-button>
          <a-button v-if="orderId!=0&&ruleForm.travelMadeOrderStatus==0" @click="overbtn(ruleForm.travelMadeOrderNo)">
            关闭订单
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import moment from 'moment'
import formMixins from '../../../../utils/mixins/formMixins'

export default {
  name: 'NewOrders',
  mixins: [formMixins],
  data() {
    return {
      moment,
      orderId: this.$route.query.orderId,
      submitLoading: false,
      uploadFileUrl: this.getUploadFileUrl(),
      fileList: [],
      currentFormLayout: {
        labelCol: {
          xxl: { span: 3 },
          xl: { span: 3 },
          lg: { span: 3 },
          sm: { span: 3 },
          md: { span: 5 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 21 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 21 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 21 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 21 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 16 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        },
        offsetCol: {
          xxl: { offset: 3 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { offset: 3 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { offset: 3 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { offset: 3 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { offset: 5 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { offset: 10 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      ruleForm: {
        travelMadeOrderAdultsNum: 1,
        travelMadeOrderAmt: '',
        travelMadeOrderChildNum: 0,
        travelMadeOrderContact: '',
        travelMadeOrderDate: '',
        travelMadeOrderInternalNo: '',
        travelMadeOrderMobile: '',
        travelMadeOrderName: '',
        travelMadeOrderPdfUrl: '',
        selectDate: undefined,
        travelMadeOrderPdfName: ''
      },
      disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().startOf('day')
      },
      rules: {
        travelMadeOrderName: [
          { required: true, message: '请输入方案名称', trigger: 'blur' }
        ],
        travelMadeOrderContact: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        travelMadeOrderMobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        travelMadeOrderAmt: [
          { required: true, message: '请输入订单金额', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的订单金额',
            trigger: 'blur'
          }
        ],
        travelMadeOrderAdultsNum: [
          { pattern: /^[1-9]\d*$/, message: '请输入正整数', trigger: 'blur' }
        ],
        travelMadeOrderChildNum: [
          { pattern: /^[0-9]\d*$/, message: '请输入正整数', trigger: 'blur' }
        ],
        selectDate: [
          { required: true, message: '请选择出游日期', trigger: 'change' }
        ]
      },
      submitFormData: ''
    }
  },
  mounted() {
  },
  activated() {
    this.getLogUtils().logWithTag('activated', 'activated')
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'BookList', title: '预约列表' },
      { name: 'CustomOrderList', title: '订单管理' }
    ])
    this.orderId = this.$route.query.orderId
    this.getCustomDetails()
  },
  methods: {
    // 返回订单列表（按当前路由上下文：新模块回定制游服务对应tab，旧模块回旧订单列表）
    goOrderList() {
      const inTravelMode = this.$route.name === 'TravelNewOrder'
      this.$router.push({
        name: inTravelMode ? 'TravelMode' : 'CustomOrderList',
        query: {
          updateFlag: true,
          tab: inTravelMode ? (this.$route.query.backTab || 'order') : undefined,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    },
    //获取图片上传地址
    getUploadFileUrl() {
      let appConfig = this.getAppConfig()
      return appConfig.baseUrl + (appConfig.isDev ? '/' : '') + 'base/upload'
    },
    checkForm() {
      if (this.fileList.length < 1) {
        this.$message.error('请上传方案附件')
        return false
      } else if (this.fileList.length > 1) {
        this.$message.error('只能上传一份附件')
        return false
      }
      if (this.fileList && this.fileList.length > 0) {
        if (!this.fileList[0].url) {
          this.$message.error('上传方案附件有误，请重新上传')
          return false
        }
      }
      return true
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.checkForm()) {
            this.submitData()
          }
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.ruleForm.travelMadeOrderPdfName = this.fileList[0].name
      this.ruleForm.travelMadeOrderPdfUrl = this.fileList[0].url
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      delete this.submitFormData.selectDate
      this.submitLoading = true
      this.getLogUtils().logWithTag('submitFormData', this.submitFormData)
      this.getHttpServices().getOrderService().post('orderCustomMade/generateOrderCustomMade', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('定制游订单保存成功')
        setTimeout(() => {
          this.goOrderList()
        }, 500)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 获取订单信息
    getCustomDetails() {
      if (this.orderId != 0) {
        this.getHttpServices().getOrderService().post('orderCustomMade/getCustomMadeOrderDetails/' + this.orderId).then(res => {
          this.getLogUtils().logWithTag('getCustomMadeOrderDetails', res)
          this.ruleForm = res
          this.ruleForm.selectDate = moment(res.travelMadeOrderDate, 'YYYY-MM-DD')
          this.fileList = [{
            uid: '-1',
            name: res.travelMadeOrderPdfName,
            status: 'done',
            url: res.travelMadeOrderPdfUrl
          }]
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      } else {
        this.resetForm()
        this.fileList = []
        //this.ruleForm.travelMadeOrderPdfName = "";
        //this.ruleForm.travelMadeOrderPdfUrl = "";
        this.ruleForm = {
          travelMadeOrderAdultsNum: 1,
          travelMadeOrderAmt: '',
          travelMadeOrderChildNum: 0,
          travelMadeOrderContact: '',
          travelMadeOrderDate: '',
          travelMadeOrderInternalNo: '',
          travelMadeOrderMobile: '',
          travelMadeOrderName: '',
          travelMadeOrderPdfUrl: '',
          selectDate: undefined,
          travelMadeOrderPdfName: ''
        }
      }
    },
    // 提前结束
    overbtn(orderNo) {
      let that = this
      this.$confirm({
        title: '请确认是否关闭此订单?',
        onOk() {
          that.closeOrder(orderNo)
        },
        onCancel() {
          that.$message.warning('已取消')
        }
      })
    },
    closeOrder(orderNo) {
      this.getHttpServices().getOrderService().post('orderCustomMade/closeCustomMadeOrder?travelMadeOrderNo=' + orderNo).then(res => {
        this.getLogUtils().logWithTag('overbtn', res)
        this.$message.success('订单关闭成功')
        setTimeout(() => {
          this.goOrderList()
        }, 500)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    resetForm() {
      this.$refs.ruleForm.resetFields()
    },
    // 图片上传
    handleChange({ fileList }) {
      this.getLogUtils().logWithTag('handleChange', fileList)
      this.fileList = fileList
      this.fileList = this.fileList.map(file => {
        if (file.response) {
          file.url = file.response.data
        }
        return file
      })
      this.getLogUtils().logWithTag('图片上传成功', this.fileList)
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.getLogUtils().logWithTag('图片删除成功', this.fileList)
      this.ruleForm.travelMadeOrderPdfName = ''
      this.ruleForm.travelMadeOrderPdfUrl = ''
    },
    handleBefore(file) {
      this.getLogUtils().logWithTag('handleBefore', file)
      // 限制图片 格式、size、分辨率
      const isPDF = file.type === 'application/pdf'
      if (!isPDF) {
        this.$message.error('上传附件的格式不正确，不是PDF')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        this.$message.error('上传的文件不能大于10M!')
        return false
      }
      return true
    },
    onDateChange(date, dateString) {
      this.getLogUtils().logWithTag('date', date)
      this.getLogUtils().logWithTag('dateString', dateString)
      this.ruleForm.selectDate = date
      this.ruleForm.travelMadeOrderDate = dateString
    }
  }
}
</script>
<style scoped lang="less">
@import url('../../../CustomPage.less');

.ant-btn + .ant-btn {
  margin-left: 10px;
}

.maxW250 {
  max-width: 250px;
}

.maxW400 {
  max-width: 400px;
}

.pl5 {
  padding-left: 5px;
}

.pr5 {
  padding-right: 5px;
}

.pr10 {
  padding-right: 10px;
}
</style>
<style lang="less">
.page {
  .ant-upload.ant-upload-drag {
    max-width: 400px;
  }
}
</style>